import React from "react";
import { Link } from "react-router-dom";
import { Container, Row } from "reactstrap";

const Cta = () => {
  return (
    <React.Fragment>
      <section className="section">
        <Container>
          <Row className="justify-content-center">
            <div className="section-title text-center">
              <h3 className="title mb-4 pb-2">
                Gestiona tu equipo de trabajo en solo lugar
              </h3>
              <p className="para-desc text-muted mx-auto">
                Comienza a trabajar con Avanaza y encuentra a los mejores talentos para tu equipo de trabajo.
              </p>
              <div className="mt-4">
                <Link to="#" className="btn btn-primary btn-hover mt-2">
                  <i className="uil uil-rocket"></i> Empieza ahora
                </Link>
                <Link
                  to="#"
                  className="btn btn-outline-primary btn-hover ms-sm-1 mt-2"
                >
                  <i className="uil uil-capsule"></i> Contacto
                </Link>
              </div>
            </div>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Cta;
